import PersonalFinances from './PersonalFinances';

export default PersonalFinances;
